import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Property API calls
export const propertyAPI = {
  getInfo: async () => {
    const response = await axios.get(`${API}/property/info`);
    return response.data;
  },
  
  getHighlights: async () => {
    const response = await axios.get(`${API}/property/highlights`);
    return response.data;
  },
  
  getDetails: async (lang = 'de') => {
    const response = await axios.get(`${API}/property/details?lang=${lang}`);
    return response.data;
  },
  
  getExpose: async (lang = 'de') => {
    const response = await axios.get(`${API}/property/expose?lang=${lang}`);
    return response.data;
  },
  
  getTransactionProcess: async (lang = 'de') => {
    const response = await axios.get(`${API}/property/transaction-process?lang=${lang}`);
    return response.data;
  },
  
  getPricing: async () => {
    const response = await axios.get(`${API}/property/pricing`);
    return response.data;
  },
  
  getEconomics: async () => {
    const response = await axios.get(`${API}/property/economics`);
    return response.data;
  }
};

// Contact API calls
export const contactAPI = {
  submitInquiry: async (inquiryData) => {
    const response = await axios.post(`${API}/contact/submit`, inquiryData);
    return response.data;
  }
};
